export default {
  apiEndpoint: 'https://webapi.beta.carrierhub.transportation.amazon.dev',
  signinURL: 'https://carrierlogistics.integ.amazon.com/ap/signin',
  signoutURL: 'https://carrierlogistics.integ.amazon.com/ap/signin',
  signupURL: 'https://carrierlogistics.integ.amazon.com/ap/register',
  auth_redirect_params_signin: {
    _encoding: 'UTF8',
    'openid.assoc_handle': 'amzn_passport_carrierhub_us',
    pageId: 'amzn_passport_carrierhub_us',
    'openid.claimed_id': 'http://specs.openid.net/auth/2.0/identifier_select',
    'openid.identity': 'http://specs.openid.net/auth/2.0/identifier_select',
    'openid.mode': 'checkid_setup',
    'openid.ns': 'http://specs.openid.net/auth/2.0',
    'openid.ns.pape': 'http://specs.openid.net/extensions/pape/1.0',
    'openid.pape.max_auth_age': 0,
    'openid.return_to':
      'https://carrierlogistics.integ.amazon.com/landing-page',
  },
  auth_redirect_params_signout: {
    'openid.claimed_id': 'http://specs.openid.net/auth/2.0/identifier_select',
    'openid.identity': 'http://specs.openid.net/auth/2.0/identifier_select',
    'openid.assoc_handle': 'amzn_passport_carrierhub_us',
    'openid.mode': 'logout',
    'openid.ns': 'http://specs.openid.net/auth/2.0',
    'openid.return_to': 'https://carrierlogistics.integ.amazon.com/',
  },
  auth_redirect_params_signup: {
    'openid.return_to': 'https://carrierlogistics.integ.amazon.com/profile',
    'openid.identity': 'http://specs.openid.net/auth/2.0/identifier_select',
    'openid.assoc_handle': 'amzn_passport_carrierhub_us',
    'openid.mode': 'checkid_setup',
    'openid.claimed_id': 'http://specs.openid.net/auth/2.0/identifier_select',
    pageId: 'amzn_passport_carrierhub_us',
    'openid.ns': 'http://specs.openid.net/auth/2.0',
  },
  devSiteCookies: {
    carrierlogistics: '',
    forecast:
      'H4sIAAAAAAAA/8WSwUoDMRCG3yXnza6rVmFvpSAVQaXqSTzMJrO7sUmmTCa1tuy7S6VCfYH2NvyX+fn+b6fAWrQL1w+SVPP+USjGQOv/kfHgwuHO7J/WyOwsJtXs1AyYHfI8t82cAj5Dj6pRg8gqNVWFG0GO4DtiNJAkO92igM5JIyTRtW6zWaLg7QTh5tro2l5Ouotgu5o/+zJdlRBgSxG+UmkoVC5a3JSDBK+K49cvAuLMjGLn+swgjuIZWkyzDMRui/btfpoS7vmdvMR+gUeSO8rRnokBRnEG5NQYxkIJQ0z+d/8H/D4o6yAsyOOxtmOhkqHVn+avtMS9MGr8AevqaSsRAwAA',
    capacity:
      'H4sIAAAAAAAA/8WTT08CQQzFv8uc2V1kQXBuhMRADGpAT8ZDma27DTNTnOnyN3x3swSNHrzCremh75f3Xg8KigKLGZWVRKXf3lsqoOP135WxQO4818E+rTEEKjAqfVAjCIEwjOuFHrPDZyhRaVWJrKLOMtwKBg/WwAoMyc6BhxIdeqkpWaBAsqjNEgX7PYTbrklu8qWlvN8OtPscpDFPwcGePWxiathl5AvcppU4q1q/pecCQmbE/oPKOoAQ+ytQDGupONAei9fJMEZs/Ls4RJPAI8s91764kgfohQzIpW04tpQE8NGe8n/A3bmyBG7GFv+prdIKgtewiZrAad1p5/3BXWfQ6w5yHdhiNmUf5/nEr9mcLjfHktGZf/rD3+hHw6vv33nhJTYtVMcvJAWXwGYDAAA=',
    npc:
      'H4sIAAAAAAAA/8VTPW/CMBD9L55JAiUB1RtCqkAVFEE7VR0O+5pYxD5knwMF8d+rIFqVoStspxvee3ofRwFao16asuIg5PtHR3i01Fy/VA3GXu7o65cGvTcag5BHMQbvDfpJXMsJWVxAiUKKinkbZJbhntE7qN1WWXBQokXH0SRrZEhiSBCSdVQbZBwWCINcJSGvmv6+12yC9Wnop2DhQA52IVVkM+M07tOKbS06f6lXDGzUmNynKaMHNuTuoGIUuSJvDqjfpqMQsPXv5iLaBObETxSdvpMH6Ngo4FvbcOoI9uBCfc7/Gb8ulTVgl1TjP7UVUoB3EnZBGrBS5kXxMOw95t1Bt5Ceasxm5MKqP3UNqTNyC5bMF+PZr/6WOija/szmlTbYFlCcvgGbI/ugYQMAAA==',
  },
  rumUIParams: {
    APPLICATION_ID: 'f2ced7bb-d959-47f1-a8e7-23d3d833675b',
    APPLICATION_VERSION: '1.0.0',
    config: {
      sessionSampleRate: 1,
      guestRoleArn:
        'arn:aws:iam::576452334837:role/carrierlogistics-RUM-UnauthenticatedRole',
      identityPoolId: 'us-east-1:a94b6056-2cde-4891-b9af-a20d5ec1cafd',
      endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
    },
    APPLICATION_REGION: 'us-east-1',
  },
};
